export default "__VITE_ASSET__CGW34KjH__"